import React from "react";
import { personalInfo, education } from "../data/mock";

const Footer = () => (
  <footer className="nb-foot">
    <p>
      <span className="mono">{personalInfo.filename}</span>
      <span aria-hidden="true"> · </span>
      last checkpoint Aug 2026
      <span aria-hidden="true"> · </span>
      {education.university}
    </p>
    <p>
      <a href={`mailto:${personalInfo.email}`}>mail</a>
      <span aria-hidden="true"> · </span>
      <a href={personalInfo.github}>github</a>
      <span aria-hidden="true"> · </span>
      <a href={personalInfo.cv} download>
        cv.pdf
      </a>
    </p>
  </footer>
);

export default Footer;
